export const EDIT_MODULE_START = 'EDIT_MODULE_START';
export const EDIT_MODULE_COMPLETE = 'EDIT_MODULE_COMPLETE';
export const EDIT_MODULE_ERROR = 'EDIT_MODULE_ERROR';
export const EDIT_MODULE_WEBHOOK_ERROR = 'EDIT_MODULE_WEBHOOK_ERROR';
export const CLOSE_MODAL = 'CLOSE_MODAL';
